module.exports = __webpack_public_path__ + "img/icon-dock-placeholder.72f08f7c.svg";